
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import { mdiArrowLeft } from "@mdi/js";
import uiService from "../../services/uiService";

export default Vue.extend({
  data() {
    return {
      mdiArrowLeft,
      binding: {},
      enrollmentCredentials: null,
      listInfo: [
        {
          keyData: "display_name",
          subDetail: this.$t('ACCOUNT.DISPLAY_NAME'),
          detailInfor: "",
        },
        {
          keyData: "email",
          subDetail: this.$t('ACCOUNT.EMAIL'),
          detailInfor: "",
        },
        {
          keyData: "phone_number",
          subDetail: this.$t('ACCOUNT.PHONE_NUMBER'),
          detailInfor: "",
        },
        {
          keyData: "user_id",
          subDetail: this.$t('ACCOUNT.USER_ID'),
          detailInfor: "",
        },
        {
          keyData: "sdp_client_id",
          subDetail: this.$t('ACCOUNT.CLIENT_ID'),
          detailInfor: "",
        },
      ],
    };
  },
  methods: {
    async logoutAllDevices() {
      if (
        await uiService.executeCommand(
          "confirmShow",
          {
            message: this.$t('LAYOUT.DO_YOU_REALLY_WANT_TO_LOGOUT_ALL_DEVICES'),
            title: this.$t('LAYOUT.CONFIRM_LOGOUT_ALL_DEVICE'),
            cancel: this.$t('LAYOUT.CANCEL'),
            ok: this.$t('LAYOUT.LOGOUT_ALL'),
          },
          true
        )
      ) {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("authenLogout", {
              all_device: true,
            });
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
        sessionStorage.removeItem('userId');
      }
    },
  },
  async created() {
    await msDataProvider.bindDataMany(
      [
        "authenAuthenInfo",
        "deviceBasicInfo",
      ],
      this.binding,
      this,
      null,
      this
    );
    this.enrollmentCredentials = await msDataProvider.executeCommand(
      "enrollmentGetCredentials"
    );
    for (const item of this.listInfo) {
      if (
          (this.binding.authenAuthenInfo.user_info &&
        this.binding.authenAuthenInfo.user_info[item.keyData]) ||
        this.enrollmentCredentials[item.keyData]
      ) {
        item.detailInfor = this.binding.authenAuthenInfo.user_info[item.keyData]
          ? this.binding.authenAuthenInfo.user_info[item.keyData]
          : this.enrollmentCredentials[item.keyData];
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
